const Switcher = ({ children, value }) => {
    return children[value] || null;
};

export { Switcher };
